import DateRangePicker from './dateRangePicker.container';

export default DateRangePicker;
